import {Component, Inject, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ReservationData} from "../../../models/reservationData";
import {FormBuilder, FormGroup} from "@angular/forms";

@Component({
    selector: 'select-incoming-training-dialog',
    templateUrl: './selectIncomingTrainingDialog.component.html',
    styleUrls: ['./selectIncomingTrainingDialog.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class SelectIncomingTrainingDialogComponent {
    data: any;
    reservations: ReservationData[];
    form: FormGroup;

    constructor(
        public matDialogRef: MatDialogRef<SelectIncomingTrainingDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private _formBuilder: FormBuilder,
    ) {
        this.data = _data.data;
        this.reservations = this.data.reservations;
        this.form = this.createForm();
    }

    createForm(): FormGroup {
        return this._formBuilder.group({
            id: [],
        });
    }

}
